<template>
  <div id="app" class="bg-black overflow-x-hidden">
    <!-- <sistema-coordenadas></sistema-coordenadas> -->
    <router-view></router-view>
    <barra-herramientas />
    <!-- <AppApplication></AppApplication> -->
  </div>
</template>

<script>
// import Intro from "@/views/Intro";
// import AppApplication from "@/views/Application";
import "animate.css";
import BarraHerramientas from "./components/BarraHerramientas.vue";
// import SistemaCoordenadas from "./views/SistemaCoordenadas.vue";
export default {
  name: "App",

  components: {
    BarraHerramientas,
    // AppApplication,
    // Intro,
    // SistemaCoordenadas,
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Exo+2:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Roboto+Mono:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700&display=swap");
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
